module.exports = __webpack_public_path__ + "35c373b2b241a663c6104b570b45da08.MP3";